import DateAndTime from 'date-and-time';

/**
 * Formats an event's start and end dates.
 *
 * @param {string} sStartDate - Start date time from DAD
 * @param {string} sEndDate - End date time from DAD
 * @returns {string}
 */
export const fnFormatEventDate = (sStartDate, sEndDate) => {
  if (!sStartDate && !sEndDate) {
    return '';
  }

  let sFormatted = '';
  const oStartDate = DateAndTime.parse(sStartDate, 'YYYY-MM-DDTHH:mm:ss');
  const oEndDate = DateAndTime.parse(sEndDate, 'YYYY-MM-DDTHH:mm:ss');

  const sStartMonth = DateAndTime.format(oStartDate, 'MMM');
  const sStartDay = DateAndTime.format(oStartDate, 'DD');

  const sEndMonth = DateAndTime.format(oEndDate, 'MMM');
  const sEndDay = DateAndTime.format(oEndDate, 'DD');

  const bIsSingleDayEvent = DateAndTime.isSameDay(oStartDate, oEndDate);

  if (bIsSingleDayEvent) {
    sFormatted = `${sStartMonth} ${sStartDay}`; // Jan 01
  } else if (sStartMonth === sEndMonth) {
    sFormatted = `${sStartMonth} ${sStartDay} - ${sEndDay}`; // Jan 01 - 11
  } else {
    sFormatted = `${sStartMonth} ${sStartDay} - ${sEndMonth} ${sEndDay}`; // Jan 25 - Feb 02
  }
  return sFormatted;
};

/**
 * Formats an event's start and end times.
 *
 * @param {string} sStartDate - Start date time from DAD
 * @param {string} sEndDate - End date time from DAD
 * @returns {string}
 */
export const fnFormatEventTime = (sStartDate, sEndDate) => {
  if (!sStartDate && !sEndDate) {
    return '';
  }

  let sFormatted = '';
  const oStartDate = DateAndTime.parse(sStartDate, 'YYYY-MM-DDTHH:mm:ss');
  const oEndDate = DateAndTime.parse(sEndDate, 'YYYY-MM-DDTHH:mm:ss');

  const sStartMonth = DateAndTime.format(oStartDate, 'MMM');
  const sStartDay = DateAndTime.format(oStartDate, 'DD');
  const sStartTime = DateAndTime.format(oStartDate, 'h:mm A');

  const sEndMonth = DateAndTime.format(oEndDate, 'MMM');
  const sEndDay = DateAndTime.format(oEndDate, 'DD');
  const sEndTime = DateAndTime.format(oEndDate, 'h:mm A');

  const bIsSingleDayEvent = DateAndTime.isSameDay(oStartDate, oEndDate);
  const bTimeIsTbd = oEndDate - oStartDate < 300000; // Event length is less than 5 minutes

  if (bTimeIsTbd) {
    sFormatted = 'TBD';
  } else if (bIsSingleDayEvent) {
    sFormatted = `${sStartTime} - ${sEndTime}`; // 10:00 AM - 11:30 AM
  } else {
    sFormatted = `${sStartMonth} ${sStartDay} at ${sStartTime} - ${sEndMonth} ${sEndDay} at ${sEndTime}`; // Jan 27 at 10:00 AM - Feb 01 at 11:30 AM
  }

  return sFormatted;
};
